import { redirectToAppMobile } from '../../utils/redirectToApp'
import { getMatchingPlayerUrlOrigin } from '../../utils/utils'


export default [{
	path: '/dynamic-list/weekly',
	component: () => {
		const playerUrlOrigin = getMatchingPlayerUrlOrigin()
		const playerUrl = `${playerUrlOrigin}/dynamic-list/weekly`
		const userAgent = navigator.userAgent.toLowerCase()
		if (window.mobilecheck() && !/android/i.test(userAgent)) {
			redirectToAppMobile('dynamic-list/weekly')
			setTimeout(() => {
				window.location.replace(playerUrl)
			}, 2000)
		} else {
			window.location.replace(playerUrl)
		}
	}
}]



// WEBPACK FOOTER //
// ./src/pages/dynamicList/dynamicListRoutes.js